// extracted by mini-css-extract-plugin
export default {"wrapper":"ImagePicker_wrapper__Q7-2Z","preview":"ImagePicker_preview__pBXgx","placeholder":"ImagePicker_placeholder__MwXdX","button":"ImagePicker_button__NMkB+"};